<div class="bk-segmented" role="tablist">
  <button *ngFor="let option of options" type="button" class="bk-segmented__item" role="tab"
    [attr.aria-selected]="option.value === value"
    [class.bk-segmented__item--active]="option.value === value"
    (click)="select(option.value)">
    {{ option.label }}
  </button>
</div>
